<template>
    <a href="javascript:void(0)" class="relative inline-block w-full text-center" @click="toggleDarkMode">                    
        <svg fill="currentColor" viewBox="0 0 20 20" v-if="this.theme === 'light'" class="w-3 h-3 m-3 mx-auto fill-current text-letter-submenu group-hover:text-tertiary">
            <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
        </svg>
        <svg fill="currentColor" viewBox="0 0 20 20" v-else class="w-3 h-3 m-3 mx-auto fill-current text-letter-submenu group-hover:text-tertiary">
            <path d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clip-rule="evenodd" fill-rule="evenodd"></path>
        </svg>
    </a>
</template>
<script>
    export default {
        data() {
            return {
                theme: null
            }
        },
        created() {
            let mediaScreen = (window.matchMedia('(prefers-color-scheme: dark)').matches) ? 'dark' : 'light';
            this.theme = localStorage.getItem('theme') || mediaScreen || document.documentElement.getAttribute('data-theme');
            this.transition();
            document.documentElement.setAttribute('data-theme', this.theme)
        },
        methods:{
            toggleDarkMode() {
                this.theme = this.theme === 'light' ? 'dark' : 'light';
                localStorage.setItem('theme', this.theme);
                this.transition();
                document.documentElement.setAttribute('data-theme', this.theme)
            },
            transition() {
                document.documentElement.classList.add('transitionMode');
                window.setTimeout(() => {
                    document.documentElement.classList.remove('transitionMode')
                }, 1000)
            }
        }
    }
</script>
<style></style>